type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: Props) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      <span className="inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm">
        <i className="ri-subtract-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">{title}</h2>
      {desc && <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">{desc}</p>}
    </div>
  );
}